import { Pipe, PipeTransform } from '@angular/core';

import { moedas } from '../moeda';

@Pipe({
    name: 'moedaSimbolo'
})
export class MoedaSimboloPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = moedas.findIndex(moeda => moeda.id === value);
        if (index > -1) {
            return moedas[index].simbolo;
        }
        return '';
    }
}
